export enum PAGE_TYPE {
  SEARCH_DESTINATIONS = 'searchDestinations',
  SEARCH = 'search',
  HOTEL_DETAIL = 'hotelDetail',
  TRANSPORT_DETAIL = 'transportDetail',
  REVIEW = 'review',
}

// The results steps of the funnel; every other page type is a detail step (hotel, flights, review).
export const RESULTS_STEP_PAGE_TYPES: PAGE_TYPE[] = [PAGE_TYPE.SEARCH, PAGE_TYPE.SEARCH_DESTINATIONS];

/**
 * Whether a step carries the search widget at all. The review step does not: it runs the cart
 * quotation, and a new search must not be startable out from under a cart already being priced.
 * (MPH-1159)
 *
 * The rule lives here alone. HeaderManager applies it to every CSW it can render, so nothing
 * further down — a brand branch, appShowCsw — can put one back on a step that must not have it.
 */
export const showsCsw = (pageType: PAGE_TYPE): boolean => pageType !== PAGE_TYPE.REVIEW;
